import { useEffect, useState } from "react";

export default function AdminPanel() {
  const [messages, setMessages] = useState([]);

  const fetchMessages = async () => {
    const res = await fetch("https://smapi.my-soc.org/message.php?action=list");
    const data = await res.json();
    setMessages(data);
  };

  const deleteMessage = async (id) => {
    await fetch(`https://smapi.my-soc.org/message.php?action=delete&id=${id}`);
    fetchMessages();
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ fontSize: "22px", marginBottom: "15px" }}>Admin Panel</h1>
      <a
        href="https://smapi.my-soc.org/message.php?action=export"
        style={{
          display: "inline-block",
          backgroundColor: "green",
          color: "white",
          padding: "8px 12px",
          borderRadius: "5px",
          textDecoration: "none",
          marginBottom: "20px",
        }}
      >
        Export to Excel
      </a>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {messages.map((msg) => (
          <li
            key={msg.id}
            style={{
              border: "1px solid #ccc",
              padding: "10px",
              borderRadius: "5px",
              marginBottom: "10px",
            }}
          >
            <b>{msg.name}</b> <i>({msg.created_at})</i>
            <p>{msg.message}</p>
            <button
              onClick={() => deleteMessage(msg.id)}
              style={{
                backgroundColor: "red",
                color: "white",
                padding: "5px 10px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
